import {Injectable} from '@angular/core';
import { Network } from '@capacitor/network';
import {BehaviorSubject} from 'rxjs';
import {environment} from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ConnectionService {

  private _isConnected: boolean = true;
  private readonly _isConnected$: BehaviorSubject<boolean>;

  constructor() {
    this._isConnected$ = new BehaviorSubject<boolean>(this._isConnected);
  }

  /**
   *
   */
  public async init(): Promise<void> {
    Network.addListener('networkStatusChange', status => {
      if(!environment.production) {
        console.info('Connection changed...', status.connected);
      }
      this._isConnected = status.connected;
      this._isConnected$.next(this._isConnected);
    });
  }

  get isConnected(): boolean {
    return this._isConnected;
  }

  get isConnected$(): BehaviorSubject<boolean> {
    return this._isConnected$;
  }
}
